// Plan types constants
export const PLAN_TYPES = {
  MOBILE: 'mobile-plan',
  INTERNET: 'internet-plan',
} as const;

export type PlanType = (typeof PLAN_TYPES)[keyof typeof PLAN_TYPES];

// API endpoints
export const COMPARATOR_ENDPOINTS = {
  PLANS: 'plans-comparators/plans',
  OPERATORS: 'plans-comparators/operators',
} as const;

// URL builders
export function buildPlansEndpoint(planType: PlanType = PLAN_TYPES.MOBILE): string {
  return `/${COMPARATOR_ENDPOINTS.PLANS}/?plan_type=${planType}`;
}

export function buildPlanByIdEndpoint(planId: string, planType: PlanType = PLAN_TYPES.MOBILE): string {
  return `/${COMPARATOR_ENDPOINTS.PLANS}/${planId}?plan_type=${planType}`;
}

export function buildOperatorsEndpoint(planType: PlanType = PLAN_TYPES.MOBILE): string {
  return `/${COMPARATOR_ENDPOINTS.OPERATORS}/?plan_type=${planType}`;
}
